import axios from "axios";
import { ApiPath } from "enums";
import env from "environments/env";
import { Get, Post } from "utils";

export const login = async ({ username, password }) => {
  const authBaseUrl = env.AUTH_API_URL || env.API_URL;
  const res = await axios.post(`${authBaseUrl}/${ApiPath.AuthLogin}`, {
    username,
    password,
  });
  return res?.data?.data;
};

export const getAuthMe = async ({ bearerToken, ...tokenCandidates } = {}) => {
  const authBaseUrl = env.AUTH_API_URL || env.API_URL;
  const resolvedTokenCandidate =
    bearerToken ||
    tokenCandidates?.accessToken ||
    tokenCandidates?.AccessToken ||
    tokenCandidates?.idToken ||
    tokenCandidates?.token ||
    localStorage.getItem("accessToken");

  const resolvedToken =
    typeof resolvedTokenCandidate === "string" ? resolvedTokenCandidate.trim() : "";

  const headers = resolvedToken
    ? {
        Authorization: resolvedToken.startsWith("Bearer ")
          ? resolvedToken
          : `Bearer ${resolvedToken}`,
      }
    : {};

  const res = await axios.get(`${authBaseUrl}/${ApiPath.AuthMe}`, {
    ...(Object.keys(headers).length ? { headers } : {}),
  });

  return res?.data?.data;
};

export const mfaChallenge = async (payload = {}, options = {}) => {
  const authBaseUrl = env.AUTH_API_URL || env.API_URL;
  const explicitBearerToken = options?.bearerToken;
  const challengeTokenCandidates = [
    explicitBearerToken,
    payload?.accessToken,
    payload?.AccessToken,
    payload?.idToken,
    payload?.token,
    localStorage.getItem("accessToken"),
  ];

  const resolvedChallengeToken = challengeTokenCandidates.find(
    (value) => typeof value === "string" && value.trim(),
  );

  const headers =
    resolvedChallengeToken && resolvedChallengeToken.trim()
      ? {
          Authorization: String(resolvedChallengeToken).startsWith("Bearer ")
            ? String(resolvedChallengeToken)
            : `Bearer ${resolvedChallengeToken}`,
        }
      : undefined;

  const res = await axios.post(`${authBaseUrl}/${ApiPath.AuthMfaChallenge}`, payload, {
    ...(headers ? { headers } : {}),
  });
  return res?.data?.data;
};

export const mfaVerify = async (payload = {}) => {
  const authBaseUrl = env.AUTH_API_URL || env.API_URL;
  const res = await axios.post(`${authBaseUrl}/${ApiPath.AuthMfaVerify}`, payload);
  return res?.data?.data;
};

export const logout = async () => {
  const res = await Get(`${ApiPath.Logout}`);
  return res.data;
};

export const refresh = async ({ refreshToken }) => {
  console.log({ refreshToken });
  const res = await Post(`${ApiPath.Refresh}`, { refreshToken });
  return res.data;
};
